<template>
  <div class="modal-action">
    <div class="text-center" v-if="!showGetPremium">
      <img alt="logo" src="./../assets/img/logo.svg" class="logo mb-2"/>
    </div>
    <div id="firebaseui-auth-container" v-show="!isLogged"></div>
    <div class="success-sign-in-wrapper" v-if="success">
      <div class="flex">
        <div class="w-50 text-left">
          <h2>Thank you for sign up!</h2>
          <p class="mb-2">There was only one step left.
            Please, install us extension in your browser</p>
          <a :href="CONST.STORE_EXT_URL" class="btn btn-main" target="_blank"
             @click="sentEvent">Install now</a>
        </div>
        <div class="w-50 ml-2">
          <img src="./../assets/img/kid/complete-step.svg" width="250" height="250" alt="Thank you for sign up">
        </div>
      </div>
    </div>
    <GetPremiumForm v-if="showModalCondition"
                     type="trial"
                     initialPremiumPlan="year"
                     v-on:updatesettings="saveSettings"/>
  </div>
</template>
<script>


import * as firebaseui from "firebaseui";
import firebase from "firebase/app";
import {sendRegistrationEmail, CONST, reportEvent} from "@/helpers/utils";
import {getSubs} from "@/helpers/stipe_const";
import GetPremiumForm from "@/components/GetPremiumForm";
import {db} from "../fb/firebase";

export default {
  name: 'LandingFlow',
  data: function () {
    return {
      userUID: null,
      isLogged: false,
      success: false,
      showGetPremium: true,
      settings: null,
      isPremium: false,
      testPayment: localStorage.getItem('stripeTest'),
    }
  },
  methods: {
    sentEvent(){
      reportEvent('click_install', {uid: this.userUID})
    },
    getPremium () {
      // this.$router.push('/login')
      this.showGetPremium = true
    },
    loggedHandle() {
      this.isLogged = true;
    },

    updateUserInfo(user) {
      console.log(user);
      if (user) {
        if (!user.isAnonymous && !this.isLogged) {
          this.isLogged = true;
          this.userUID = user.uid;
          this.$rtdbBind('settings', db.ref('users/' + user.uid + '/settings')).then(() => {
            console.log(this.settings);
            if (this.settings.customer) {

              this.checkTrialBought(this.settings.customer);
            }
          });
        } else {
          this.startFBUI();
        }
      }
    },

    startFBUI () {
      const $this = this;

      const ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(firebase.auth());
      ui.start('#firebaseui-auth-container', {
        signInOptions: [
          {
            provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
            requireDisplayName: false,
          }
        ],
        callbacks: {
          // eslint-disable-next-line no-unused-vars
          signInSuccessWithAuthResult(authResult, redirectUrl) {
            if (authResult.additionalUserInfo.isNewUser) {
              sendRegistrationEmail(authResult.user.email)
              $this.newUserLogged = true
            } else {
              $this.loggedHandle(authResult.user)
            }
            return false;
          },
          signInFailure(error) {
            if (error.code !== 'firebaseui/anonymous-upgrade-merge-conflict') {
              return Promise.resolve();
            }
            const cred = error.credential;
            return firebase.auth().signInWithCredential(cred);
          }
        },
      });
    },

    checkTrialBought(customer) {
      getSubs(customer, this.testPayment).then(subs => {
        subs.some((item) => {
          if (item.status === 'trialing' || item.status === 'active') {
            this.success = true;
          }
        })
      })
    },

    saveSettings(settings) {
      console.log(settings);
      if (settings.isPremium) {
        this.checkTrialBought(this.settings.customer)
      }
      const newSettings = {}
      Object.keys(settings).forEach((item) => {
        newSettings['/'+item] = settings[item]
      })
      db.ref('users/' + this.userUID).child('settings').update(newSettings).then(() => {
        console.log('user updated!')
      })
    }
  },
  mounted () {
    const { currentUser } = firebase.auth();
    this.updateUserInfo(currentUser);
    this.unsubscribeFB = firebase.auth().onAuthStateChanged((user) => {
      this.updateUserInfo(user);
    })
  },

  created() {
    this.CONST = CONST;
  },

  destroyed() {
    if (this.unsubscribeFB) {
      this.unsubscribeFB();
    }
  },

  computed: {
    showModalCondition() {
      return this.showGetPremium && this.isLogged && !this.success;
    }
  },
  components: {
    GetPremiumForm
  },
}
</script>

<style lang="scss">
@import "../assets/styles/helpers";
@import "../assets/styles/themes";
@import "../assets/styles/kid";

  .premium-page {
    max-width: 1200px;
    margin: 0 auto;

    .content-block {
      height: auto;
    }
  }
.modal-action {
  max-width: 800px;
  margin: 0 auto;
  padding: 30px 15px;
}
</style>
